"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEMA = exports.MAX_LABEL_CHARS = void 0;
const SCHEMA = 'iglu:com.angi.entities/component_attributes/jsonschema/6-0-4';
exports.SCHEMA = SCHEMA;
// Max label length defined by component_attributes schema (label.maxLength = 4096)
const MAX_LABEL_CHARS = 4096;
exports.MAX_LABEL_CHARS = MAX_LABEL_CHARS;
/**
 * Generates the component_attributes context
 *
 * @param componentType - type of component firing the event
 */
const componentAttributesContext = (componentData) => {
    const data = componentData;
    return {
        schema: SCHEMA,
        data,
    };
};
exports.default = componentAttributesContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50QXR0cmlidXRlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9kYXRhU3RydWN0dXJlcy9lbnRpdGllcy9jb21wb25lbnRBdHRyaWJ1dGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLE1BQU0sTUFBTSxHQUFHLDhEQUE4RCxDQUFDO0FBbUJwRCx3QkFBTTtBQWxCaEMsbUZBQW1GO0FBQ25GLE1BQU0sZUFBZSxHQUFHLElBQUksQ0FBQztBQWlCcEIsMENBQWU7QUFmeEI7Ozs7R0FJRztBQUNILE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxhQUFrQyxFQUFzQixFQUFFO0lBQzFGLE1BQU0sSUFBSSxHQUF3QixhQUFvQyxDQUFDO0lBQ3ZFLE9BQU87UUFDSCxNQUFNLEVBQUUsTUFBTTtRQUNkLElBQUk7S0FDUCxDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUsMEJBQTBCLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/dataStructures/entities/componentAttributes.ts